import * as React from "react";

import './RegisteredStatusBox.pcss';

export const RegisteredStatusBox = (props:{eventName:string}) =>
  <div className={"registered-status-box"} aria-label={`You are registered for ${props.eventName}`}>
    <span aria-hidden className="material-icons">check_circle</span>
    <span aria-hidden className={"text"}>Registered</span>
  </div>
;
